export default {
  removeBgGridItemContainer: 'remove-bg-grid-item-container',
  removeBgGridItemTexture: 'remove-bg-grid-item-texture',
  removeBgGridItemImage: 'remove-bg-grid-item-image',
};
